// extracted by mini-css-extract-plugin
export default {"contactWrapper":"styles_contactWrapper__qx-hM","expanded":"styles_expanded__vtU2b","assignedTo":"styles_assignedTo__NYuOG"};